import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreditFirstTimeBorrowRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CreditFirstTimeBorrowResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const creditFirstTimeBorrow = (request: CreditFirstTimeBorrowRequest, options?: CashRequestOptions) =>
  post<CreditFirstTimeBorrowRequest, CreditFirstTimeBorrowResponse>('/2.0/cash/credit-first-time-borrow', request, {
    ...options,
    rejectOnError: true,
  })
